import * as React from 'react';

import { Pagination } from '@/components/Pagination';

import { AI_ASK_RESULTS_PAGE_SIZE } from '../../constants';
import type { AiSearchResultsSectionState } from '../../types';
import type { AiAskIndexData } from '../../utils/aiAskHelpers';
import { renderAiSearchResultsList } from './indexRegistry';

export const PaginatedResultsSection: React.FC<{
  sectionState: AiSearchResultsSectionState;
  indexData: AiAskIndexData;
}> = ({ sectionState, indexData }) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const totalHits = sectionState.hits.length;
  const numberOfPages = Math.max(
    1,
    Math.ceil(totalHits / AI_ASK_RESULTS_PAGE_SIZE)
  );

  React.useEffect(() => {
    setCurrentPage(1);
  }, [sectionState.index, totalHits]);

  React.useEffect(() => {
    if (currentPage > numberOfPages) {
      setCurrentPage(numberOfPages);
    }
  }, [currentPage, numberOfPages]);

  const paginatedSection = React.useMemo((): AiSearchResultsSectionState => {
    const start = (currentPage - 1) * AI_ASK_RESULTS_PAGE_SIZE;
    const end = start + AI_ASK_RESULTS_PAGE_SIZE;

    return {
      ...sectionState,
      hits: sectionState.hits.slice(start, end),
    } as AiSearchResultsSectionState;
  }, [sectionState, currentPage]);

  if (totalHits === 0) {
    return null;
  }

  return (
    <>
      {renderAiSearchResultsList(paginatedSection, indexData)}
      <Pagination
        currentPage={currentPage}
        numberOfPages={numberOfPages}
        onChange={setCurrentPage}
      />
    </>
  );
};
